/** SettingsRoute — skin-aware switcher for /settings. */
import { useUISkin } from "@/data/UISkinContext";
import Settings from "./Settings";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function SettingsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Admin · Configuration" title="Settings">
        <Settings />
      </CockpitFrame>
    );
  }
  return <Settings />;
}
